import React, {useState} from 'react';
import {Box, Grid} from '@material-ui/core';
import RateBreakdownSelector from '@generic/pages/ChargingCalculator/RateBreakdownSelector';
import RateComponentCategoryChart from '@generic/pages/ChargingCalculator/RateComponentCategoryChart';
import RateChargePanel from '@generic/pages/ChargingCalculator/RateChargePanel';
import SupportingCopyPrintout from '@generic/pages/ChargingCalculator/SupportingCopyPrintout';
import PlanningSiteMonthlyDemand from '@generic/pages/SitePlanner/PlanningSiteMonthlyDemand';
import PlanningSiteLoadProfile from '@generic/pages/SitePlanner/PlanningSiteLoadProfile';
import ElectricityBill from '@generic/pages/ChargingCalculator/ElectricityBill';
import {getRates} from '@generic/data/rates';
import calcChargerSetFacilityLoadProfile from '@generic/functions/calcChargerSetFacilityLoadProfile';
import {LoadProfile, RateCalculator} from '@bellawatt/electric-rate-engine';
import {YEAR} from '@generic/data/assumptions';
import calcScaledFacilityLoadProfile from '@generic/functions/calcScaledFacilityLoadProfile';
import {useInputs} from '@bellawatt/use-inputs';

export default function RateBreakdown() {
  const inputs = useInputs();
  const {separatelyMetered} = inputs;
  RateCalculator.shouldValidate = false;

  const chargerLoadProfileData = calcChargerSetFacilityLoadProfile(inputs);
  const chargerLoadProfile = new LoadProfile(chargerLoadProfileData, {year: YEAR});
  const totalLoadProfile = separatelyMetered
    ? chargerLoadProfile
    : chargerLoadProfile.aggregate(calcScaledFacilityLoadProfile(inputs));

  const maxDemand = totalLoadProfile.max();

  const rates = getRates(inputs, maxDemand);

  const [rate, setRate] = useState(rates[0]);
  const [selectedRateComponent, setSelectedRateComponent] = useState('energy');

  const handleChange = (rateName) => {
    setRate(rates.find((r) => r.name === rateName) || rates[0]);
  };

  const rateCalculator = new RateCalculator({
    ...rate,
    loadProfile: totalLoadProfile,
  });

  return (
    <Box mt={5}>
      <RateBreakdownSelector
        rateName={rate.name}
        handleChange={handleChange}
        maxDemand={maxDemand}
      />

      <SupportingCopyPrintout rateName={rate.name} />

      <Grid container>
        <Grid item xs={12} lg={6}>
          <RateComponentCategoryChart
            rateCalculator={rateCalculator}
            onHover={setSelectedRateComponent}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <Box px={10} display="flex" justifyContent="center">
            <RateChargePanel
              rateCalculator={rateCalculator}
              loadProfile={totalLoadProfile}
              rateTitle={rate.title}
              rateComponent={selectedRateComponent}
            />
          </Box>
        </Grid>
      </Grid>

      <PlanningSiteMonthlyDemand />
      <PlanningSiteLoadProfile />

      <ElectricityBill
        rateCalculator={rateCalculator}
        loadProfile={totalLoadProfile}
        rateTitle={rate.title}
      />
    </Box>
  );
}
